/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Styles from './TextInput.css';
import clsx from 'clsx';

function TextInput({ children, completed, error, floatingLabel, ...props }) {
  return (
    <>
      <div
        className={clsx(
          'sn-text-input',
          props.disabled && 'disabled',
          !!floatingLabel && 'text-input-label',
        )}
      >
        <input
          {...props}
          placeholder={floatingLabel ? undefined : props.placeholder}
          className={[
            !!error ? 'input-has-error' : '',
            completed ? 'input-completed' : '',
            props.className,
            !!props.value ? 'has-filled-value' : '',
          ].join(' ')}
        />

        {floatingLabel && <label for={props.id}>{floatingLabel}</label>}

        {children && <span className="ic-container">{children}</span>}

        {!children && completed && (
          <span className="ic-container">
            <img src="assets/rastreadores/success.svg" alt="" />
          </span>
        )}

        {!children && error && (
          <span className="ic-container">
            <img src="assets/rastreadores/error.svg" alt="" />
          </span>
        )}
      </div>
      {error && <p className="input-error-text">*{error}</p>}
      <style jsx>{Styles}</style>
    </>
  );
}

export default TextInput;
